import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function PageHeader({ title, subtitle, back = false }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 bg-[#FAF8F5]/92 px-6 pb-4 pt-7 backdrop-blur-md">
      <div className="flex items-center gap-3">
        {back && (
          <button
            data-testid="page-back-btn"
            onClick={() => navigate(-1)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-sm"
            aria-label="Retour"
          >
            <ArrowLeft size={20} color="#36302B" />
          </button>
        )}
        <div>
          <h1 className="font-display text-3xl font-medium leading-tight text-[#36302B]">{title}</h1>
          {subtitle && <p className="mt-1 text-[14px] text-[#36302B]/60">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
}
